class CustomDetailsElement extends HTMLElement {
  constructor() {
    super();

    /** @type HTMLElement */
    this.detailsEl = this.querySelector("details");

    if (this.detailsEl.classList.contains("header-dropdown")) {
      /** @type HTMLElement */
      this.dropdownEl = this.detailsEl.querySelector("ul");
    }
  }

  connectedCallback() {
    this.addEventListener("mouseenter", () => {
      this.detailsEl.setAttribute("open", "open");
      if (this.detailsEl.classList.contains("header-dropdown"))
        this.dropdownEl.classList.add("header-dropdown-menu--open");
    });

    this.addEventListener("mouseleave", () => {
      if (!this.detailsEl.classList.contains("header-dropdown"))
        return this.detailsEl.removeAttribute("open");

      this.dropdownEl.classList.remove("header-dropdown-menu--open");

      setTimeout(() => {
        this.detailsEl.removeAttribute("open");
      }, 250);
    });
  }
}

customElements.define("custom-details", CustomDetailsElement);
